import { useMemo } from "react";
import moment from "moment";
import { Badge, Heading, LoadingProgress, Table, Text } from "@/ui";
import styles from "./ActivityLogs.module.scss";

const ActivityLogs = ({ inputs, loading }) => {
    const _loading = loading || false;
    const _logs = inputs?.activity_logs || [];

    const _lastLog = _logs.length
        ? ` (Last Updated ${moment(_logs[0]?.updated).format("MMMM Do YYYY")})`
        : " (No recent activity)";

    const columns = useMemo(
        () => [
            {
                id: "action",
                header: "Action",
                width: "30%",
                minWidth: 180,
                renderCell: row => (
                    <div className={styles.primaryCell}>{row.action}</div>
                ),
            },
            {
                id: "user",
                header: "User",
                width: "25%",
                minWidth: 140,
                renderCell: row => (
                    <div className={styles.primaryCell}>{row.user}</div>
                ),
            },
            {
                id: "status",
                header: "Status",
                width: "15%",
                minWidth: 100,
                renderCell: row => {
                    const status =
                        typeof row.status === "string"
                            ? row.status.trim()
                            : row.status;
                    if (!status) {
                        return <span className={styles.secondaryCell}>-</span>;
                    }
                    return <Badge variant="neutral">{status}</Badge>;
                },
            },
            {
                id: "timestamp",
                header: "Date and hours",
                width: "30%",
                minWidth: 160,
                renderCell: row => {
                    const date = row.timestamp
                        ? moment(row.timestamp).format("MMMM Do YYYY")
                        : "";
                    const time = row.timestamp
                        ? moment(row.timestamp).format("HH:mm:ss")
                        : "";
                    return (
                        <div className={styles.dateCell}>
                            <div className={styles.primaryCell}>{date}</div>
                            <div className={styles.secondaryCell}>{time}</div>
                        </div>
                    );
                },
            },
        ],
        [],
    );

    return (
        <div className={`tap__panel_activity_logs ${styles.root}`}>
            <div className={styles.header}>
                <Heading level={5}>
                    Activity log{" "}
                    <Text as="span" tone="secondary" variant="body-md">
                        {_lastLog}
                    </Text>
                </Heading>
            </div>
            {_loading ? (
                <div className={styles.loading}>
                    <LoadingProgress
                        indeterminate
                        indicator="circular"
                        size="sm"
                        title="Loading"
                    />
                </div>
            ) : (
                <Table
                    columns={columns}
                    emptyMessage="No activity logs"
                    getRowId={row =>
                        String(row.entity_id ?? row.timestamp ?? row.action)
                    }
                    rows={_logs}
                />
            )}
        </div>
    );
};

export default ActivityLogs;
